export class Money {
  constructor(
        public readonly amount: number,
        public readonly currencyCode: string
  ) {}
}
